import React from "react";
import "./SearchInput.css";
import MdSearch from "react-icons/lib/md/search";

const SearchInput = props => {
  return (
    <div className="search-input">
      <input
        type="text"
        placeholder={props.ph}
        onChange={e => {
          props.onChange(e.target.value);
        }}
      />
      <button className="icon">
        <MdSearch size={24} />
      </button>
    </div>
  );
};

export default SearchInput;



// WEBPACK FOOTER //
// ./src/common/input/SearchInput.js